module.exports = __webpack_public_path__ + "img/loader.9b5c7376.gif";